import { render, staticRenderFns } from "./DaliTab.vue?vue&type=template&id=1304715b&scoped=true"
import script from "./DaliTab.vue?vue&type=script&lang=ts"
export * from "./DaliTab.vue?vue&type=script&lang=ts"
import style0 from "./DaliTab.vue?vue&type=style&index=0&id=1304715b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304715b",
  null
  
)

export default component.exports